import { Component } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DashboardService } from '../../services/dashboard.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.less']
})
export class ChangePasswordComponent {

	form = new UntypedFormGroup({
		old_password: new UntypedFormControl('', [Validators.required]),
		new_password: new UntypedFormControl('', [
			Validators.required,
			Validators.minLength(8),
			Validators.maxLength(32),
			Validators.pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^*-]).{8,}$/)
		]),
		new_password_repeat: new UntypedFormControl('', [
			Validators.required,
			this.repeatPasswordValidator.bind(this)
		]),
	});

	pending = false;

	oldPasswordHidden = true;
	newPasswordHidden = true;
	repeatPasswordHidden = true;

  constructor(private ref: DynamicDialogRef,
							private dashboardService: DashboardService,
							private messageService: MessageService) { }

  submitForm(): void {
		this.form.markAllAsTouched();

		if ( this.form.invalid || this.pending ) {
			return;
		}

		this.pending = true;

		const oldPassword: string = this.form.get('old_password')?.value;
		const newPassword: string = this.form.get('new_password')?.value;

		this.dashboardService.changePassword(
			oldPassword,
			newPassword
		)
			.subscribe(response => {
				this.pending = false;

				if ( response.success ) {
					this.messageService.add({
						severity: 'success',
						summary: 'Смена пароля',
						detail: 'Пароль успешно изменен',
						life: 10 * 1000,
					});

					this.closeDialog();
				} else {
					this.messageService.add({
						severity: 'error',
						summary: 'Смена пароля',
						detail: response.error ?? 'Серверная ошибка',
						life: 10 * 1000,
					});
				}

			});

	}

	closeDialog(): void {
  	this.ref.close();
	}

	repeatPasswordValidator(abstractControl: AbstractControl): ValidationErrors | null {
  	const passwordRepeat: string = (abstractControl as UntypedFormControl).value;
  	const newPassword: string = this.form?.get('new_password')?.value;

  	return passwordRepeat !== newPassword
			? {repeat: true}
			: null;
	}

	invalidateForm(): void {
		this.form.get('new_password_repeat')?.updateValueAndValidity();
	}

	getIcon(isHidden: boolean): string {
  	return isHidden
			? '/assets/images/icon_eye_slash.svg'
			: '/assets/images/icon_eye.svg';
	}

	getInputType(isHidden: boolean): string {
		return isHidden
			? 'password'
			: 'text';
	}

}
